module.exports = __webpack_public_path__ + "img/1316383002.89b9c096.jpg";